export const getProperty = (data: any, path: string) => {
  const fieldsPath = path.split('.');
  let result: any = null;
  for (const id in fieldsPath) {
    result = result ? result[fieldsPath[id]] : data[fieldsPath[id]];
  }
  return result;
};
